import React, { useState, useEffect } from 'react';
import { checkRequiresConsentBanner, acceptAll, rejectNonEssential } from '../utils/consent';
import { ensureIubendaScript } from '../utils/iubenda';
import { useT } from '../i18n/useT';

const CookieBanner = () => {
  const t = useT();
  const [visible, setVisible] = useState(false);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    checkRequiresConsentBanner().then((needed) => {
      if (needed) {
        setVisible(true);
        requestAnimationFrame(() => requestAnimationFrame(() => setAnimate(true)));
      }
    });
  }, []);

  useEffect(() => {
    if (visible) ensureIubendaScript();
  }, [visible]);

  const dismiss = () => {
    setAnimate(false);
    setTimeout(() => setVisible(false), 200);
  };

  const handleAccept = () => { acceptAll(); dismiss(); };
  const handleReject = () => { rejectNonEssential(); dismiss(); };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-[9998] flex justify-center p-4 pointer-events-none"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div
        className={`pointer-events-auto w-full max-w-xl bg-white border border-gray-200 rounded-xl shadow-lg p-5 transition-transform duration-300 ease-out ${
          animate ? 'translate-y-0' : 'translate-y-[120%]'
        }`}
      >
        <p className="text-sm text-gray-600 mb-4">
          {t('cookie_text')}{' '}
          <a href="https://www.iubenda.com/privacy-policy/52362461/cookie-policy" className="iubenda-noiframe iubenda-embed iubenda-noiframe text-indigo-600 hover:underline" title="Cookie Policy">
            {t('cookie_learn_more')}
          </a>
        </p>
        <div className="flex flex-wrap gap-3">
          <button
            onClick={handleAccept}
            className="flex-1 min-w-[140px] px-4 py-2.5 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors"
          >
            {t('cookie_accept')}
          </button>
          <button
            onClick={handleReject}
            className="flex-1 min-w-[140px] px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            {t('cookie_reject')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
